var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.033,
    height: 68.614,
    viewBox: "0 0 122.033 68.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7379",
    "data-name": "Rettangolo 7379",
    width: 122.032,
    height: 68.614,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36254",
    "data-name": "Tracciato 36254",
    d: "M3.246,2.505a.9.9,0,0,0-.9.9V15.627a.927.927,0,0,0,.226.6c.015.012,1.181-1.3,1.73-1.448L4.307,4.128H117.938S119.3,2.747,119.35,2.7a.855.855,0,0,0-.562-.194Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.02,
    y1: 4.813,
    x2: -0.011,
    y2: 4.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#e1081f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#e01f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#df4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#dd786a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc967e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36255",
    "data-name": "Tracciato 36255",
    d: "M3.362,51.2c-.561.085-1.02.417-1.02.92V64.345a.935.935,0,0,0,.228.6,8.443,8.443,0,0,1,1.714-1.415l.023-10.686L61,43.814l56.939,9.029s1.33-1.347,1.38-1.394a1.65,1.65,0,0,0-.644-.246L61,42.188Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.02,
    y1: 1.161,
    x2: -0.011,
    y2: 1.161,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#e1081f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e01f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#df4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#dd786a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc967e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9081",
    "data-name": "Raggruppa 9081",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36251",
    "data-name": "Tracciato 36251",
    d: "M.306.307v67.95l60.875-9.673,60.549,9.473V.307Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36252",
    "data-name": "Tracciato 36252",
    d: "M.609.612H121.424V67.7L61,58.275.609,67.9ZM0,0V68.614l61-9.721,60.685,9.467.351.054V0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9074",
    "data-name": "Raggruppa 9074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9073",
    "data-name": "Raggruppa 9073",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_7378",
    "data-name": "Rettangolo 7378",
    d: "M.9,0H116.449a.9.9,0,0,1,.9.9V13.127a.9.9,0,0,1-.9.9H.9a.9.9,0,0,1-.9-.9V.9A.9.9,0,0,1,.9,0Z",
    transform: "translate(2.343 2.503)",
    fill: "#e2001a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36253",
    "data-name": "Tracciato 36253",
    d: "M119.691,64.344a.9.9,0,0,1-.9.9L61,56.214,3.242,65.244a.9.9,0,0,1-.9-.9V52.122c0-.5.454-.833,1.02-.922L61,42.187s49.554,7.743,57.672,9.018c.663.137,1.02.437,1.02.917Z",
    fill: "#e2001a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9076",
    "data-name": "Raggruppa 9076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9075",
    "data-name": "Raggruppa 9075",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7380",
    "data-name": "Rettangolo 7380",
    width: 117.008,
    height: 13.736,
    transform: "translate(2.342 2.505)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9078",
    "data-name": "Raggruppa 9078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9077",
    "data-name": "Raggruppa 9077",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7381",
    "data-name": "Rettangolo 7381",
    width: 116.974,
    height: 22.756,
    transform: "translate(2.342 42.188)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9080",
    "data-name": "Raggruppa 9080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9079",
    "data-name": "Raggruppa 9079",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36256",
    "data-name": "Tracciato 36256",
    d: "M117.029,14.757a.914.914,0,0,0,.908-.9V4.13s1.346-1.363,1.412-1.432a.906.906,0,0,1,.343.708V15.629a.9.9,0,0,1-.9.9H3.243a.9.9,0,0,1-.674-.3c.67-.669,1.41-1.47,1.89-1.47Z",
    fill: "#aa140a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36257",
    "data-name": "Tracciato 36257",
    d: "M61,54.441,117.03,63.47a.911.911,0,0,0,.908-.9l0-9.727s1.34-1.356,1.381-1.393a.685.685,0,0,1,.372.672V64.345a.9.9,0,0,1-.9.9L61,56.215,3.246,65.245a.9.9,0,0,1-.674-.3,5.9,5.9,0,0,1,1.886-1.471Z",
    fill: "#aa140a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36258",
    "data-name": "Tracciato 36258",
    d: "M14.2,32.982c-.082,1.845-1.072,2.764-2.34,2.764a1.723,1.723,0,0,1-1.75-1.638c0-1.193.646-1.567,1.888-1.907a8.59,8.59,0,0,0,2.2-.855Zm5.36-4.912c0-3.41.058-6.925-6.94-6.925-3.468,0-7.364.82-7.534,5.8h5.194c.026-.751.366-1.808,2.088-1.808A1.628,1.628,0,0,1,14.2,26.774c0,1.126-.762,1.4-1.524,1.569-2.85.65-8.27.446-8.27,6.043,0,3.717,2.346,5.351,5.168,5.351a5.4,5.4,0,0,0,4.71-2.116h.058a5.717,5.717,0,0,0,.194,1.67h5.7a8.391,8.391,0,0,1-.68-3.954Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36259",
    "data-name": "Tracciato 36259",
    d: "M22.657,39.293h5.588V32.3c0-3.784,1.186-5.353,3.388-5.353a4.787,4.787,0,0,1,2.2.443V21.418a5.492,5.492,0,0,0-1.638-.273c-2.032,0-3.216,1.164-4.118,3.276h-.06V21.588h-5.36Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36260",
    "data-name": "Tracciato 36260",
    d: "M39.961,28.448c.254-1.91,1.212-2.969,2.878-2.969a2.7,2.7,0,0,1,2.456,2.969Zm10.7,3.515c0-6.895-2.512-10.817-8.328-10.817-4.626,0-7.728,4.193-7.728,9.349,0,5.9,3.528,9.243,8.208,9.243a7.516,7.516,0,0,0,7.536-5.594h-5.22a2.628,2.628,0,0,1-2.342,1.263c-1.75,0-2.71-1.433-2.848-3.444Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36261",
    "data-name": "Tracciato 36261",
    d: "M50.795,39.293h6.124l2.058-4.331,2.148,4.331h6.152l-5.192-9.31,4.6-8.4H60.7L59.065,25.1l-1.61-3.515H51.3l4.6,8.4Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36262",
    "data-name": "Tracciato 36262",
    d: "M83.343,30.424c0-4.91-2.478-9.279-7.982-9.279s-7.984,4.369-7.984,9.279,2.48,9.312,7.984,9.312,7.982-4.4,7.982-9.312m-5.582,0c0,1.875-.286,4.4-2.4,4.4s-2.4-2.527-2.4-4.4.288-4.362,2.4-4.362,2.4,2.49,2.4,4.362",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36263",
    "data-name": "Tracciato 36263",
    d: "M85.492,39.293h5.584V29.946c0-2.83,1.272-3.409,2.232-3.409,1.634,0,1.834,1.429,1.834,3.478v9.278h5.59V27.15c0-4.062-2.4-6-5.028-6a5.087,5.087,0,0,0-4.764,2.7h-.06V21.588H85.492Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36264",
    "data-name": "Tracciato 36264",
    d: "M117.041,26.741c-.142-4.535-3.952-5.6-7.11-5.6-2.932,0-6.912,1.165-6.912,5.631,0,3.036,1.722,4.674,5.978,5.561,2.6.548,3.082.854,3.082,1.874s-1.16,1.363-1.894,1.363a2.031,2.031,0,0,1-1.5-.508,2.318,2.318,0,0,1-.674-1.569h-5.336c.086,4.574,3.866,6.242,7.308,6.242,3.556,0,7.45-1.33,7.45-6.242a4.889,4.889,0,0,0-3.5-4.945c-1.858-.753-3.978-.891-4.906-1.364a1.034,1.034,0,0,1-.65-.924c0-1.16.9-1.365,1.692-1.365a1.741,1.741,0,0,1,1.242.511,1.786,1.786,0,0,1,.646,1.332Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36265",
    "data-name": "Tracciato 36265",
    d: "M114.791,19.051a1.805,1.805,0,1,0,1.808-1.784,1.794,1.794,0,0,0-1.808,1.784m.327,0a1.479,1.479,0,1,1,1.481,1.543,1.479,1.479,0,0,1-1.481-1.543m.782,1.057h.327v-.9h.344l.571.9h.353l-.6-.928a.537.537,0,0,0,.554-.568c0-.4-.237-.6-.737-.6H115.9Zm.327-1.834h.433c.219,0,.46.043.46.323,0,.329-.262.346-.553.346h-.34Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36266",
    "data-name": "Tracciato 36266",
    d: "M4.743,52.662l25.274-4.047-.5.274L5.666,53.347a.929.929,0,0,0-.83.983L4.33,61.023,3.9,61.8l-.019-8.143a.972.972,0,0,1,.861-1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36267",
    "data-name": "Tracciato 36267",
    d: "M4.115,13.642l.222-.663L5.3,5.807a.746.746,0,0,1,.743-.745l26.328-.945.368-.246H4.858a.744.744,0,0,0-.743.745Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e7338c67f7e71bdf697767e34a4bde4.svg";
export { ForwardRef as ReactComponent };